import React, { useState } from 'react'
import './App.css'
import './static/css/style.css'
import Card from './components/Card.js'
import PinDrop from './components/PinDrop.js'

import {
  BrowserRouter as Router,
  Switch,
  Route
} from 'react-router-dom'

function App () {
  const [to, setTo] = useState('')
  const [frm, setFrm] = useState('')
  const [message, setMessage] = useState('')

  const changeTo = event => {
    setTo(event.target.value)
  }

  const changeFrm = event => {
    setFrm(event.target.value)
  }

  const changeMessage = event => {
    setMessage(event.target.value)
  }

  return (
    <Router>
      <Switch>
        <Route exact path='/' >
          <PinDrop
            changeTo={changeTo}
            changeFrm={changeFrm}
            changeMessage={changeMessage}
            to={to}
            frm={frm}
            message={message}
          />
        </Route>
        <Route path='/:long/:lat/:hash' >
          <Card />
        </Route>
      </Switch>
    </Router>
  )
}

export default App
